/*
 ** vue router: MTIVentory
 */
import type { RouteRecordRaw } from 'vue-router';

const vrtMTIVentory: RouteRecordRaw = {
  path: '/powersup',
  name: 'vrtPOWERsup',
  component: () => import('src/layouts/vcleSystem.vue'),
  children: [
    {
      path: 'submit',
      name: 'vrtMTIVentorySubmit',
      component: () => import('./vpgMTIVentorySubmit.vue'),
    },
    {
      path: 'view',
      name: 'vrtMTIVentoryHistory',
      component: () => import('./vpgMTIVentoryHistory.vue'),
    },
    {
      path: 'update',
      name: 'vrtMTIVentoryUpdate',
      component: () => import('./vpgMTIVentoryUpdate.vue'),
    },
    {
      path: 'hoto',
      name: 'vrtMTIVentoryHOTO',
      component: () => import('./vpgMTIVentoryHOTO.vue'),
    },
    {
      path: 'return',
      name: 'vrtMTIVentorySign',
      component: () => import('./vpgMTIVentorySign.vue'),
    },
    {
      path: 'adjust',
      name: 'vrtMTIVentoryAdjust',
      component: () => import('./vpgMTIVentoryAdjust.vue'),
    },
    {
      path: 'report',
      name: 'vrtMTIVentoryReport',
      component: () => import('./vpgMTIVentoryReport.vue'),
    },
    {
      path: 'item',
      name: 'vrtMTIVentoryEditBII',
      component: () => import('./vpgMTIVentoryEditBII.vue'),
    },
    {
      path: 'edit',
      name: 'vrtMTIVentoryEditItemBII',
      component: () => import('./vpgMTIVentoryEditItemBII.vue'),
    },
    {
      path: 'variant',
      name: 'vrtMTIVentoryEditVariant',
      component: () => import('./vpgMTIVentoryEditVariant.vue'),
    },
    {
      path: 'variantitem',
      name: 'vrtMTIVentoryEditItem',
      component: () => import('./vpgMTIVentoryEditItem.vue'),
    },
    {
      path: 'cage',
      name: 'vrtMTIVentoryEditCages',
      component: () => import('./vpgMTIVentoryEditCages.vue'),
    },
    {
      path: 'category',
      name: 'vrtMTIVentoryEditCat',
      component: () => import('./vpgMTIVentoryEditCat.vue'),
    },
    {
      path: 'details',
      name: 'vrtMTIVentoryDetails',
      component: () => import('./vpgMTIVentoryDetails.vue'),
    },
    {
      path: 'witness',
      name: 'vrtMTIVentoryWitness',
      component: () => import('./vpgMTIVentoryWitness.vue'),
    },
    {
      path: 'print',
      name: 'vrtMTIVentoryPrint',
      component: () => import('./vpgMTIVentoryPrint.vue'),
    },
    {
      path: 'manual',
      name: 'vrtMTIUserManual',
      component: () => import('./vpgMTIUserManual.vue'),
    },
  ],
};

export default vrtMTIVentory;
